var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"fluid":"","id":"image-classes"}},_vm._l((_vm.labels),function(classType,index){return _c('Chip',{key:`${index}-${classType}`,attrs:{"color":_vm.getChipColor(classType),"size":"x-small","text":_vm.getLabelText(classType, _vm.classes)},on:{"clicked":(status) => _vm.filterAnnotes(classType, status)}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }